import * as React from "react";

interface Props {
  href: string,
  img: string,
  alt: string,
}

const SponsorLogo = ({ href, img, alt }: Props) => {
  return (
    <a href={href}><img src={img} alt={alt}/></a>
  )
}

export default SponsorLogo;